<template>
    <div class="loading"  v-show="isPageLoading == true">
        <n-spin size="large" style="left:50%;top:40%; z-index:100; position:absolute"/>
        <RobotCheckModal :isRobot="isRobotCheck"/> 
    </div>

    <div class="content">
      <div class="breadCrumb_web">
        <n-breadcrumb separator=">">
          <n-breadcrumb-item>
            <Icon size="20">
              <HomeOutline />
            </Icon>
          </n-breadcrumb-item>
        </n-breadcrumb>
      </div>
      <div class="breadCrumb_mobile">
        <n-breadcrumb separator=">">
          <n-breadcrumb-item>
              <Icon size="12">
                  <HomeOutline/>
              </Icon>
          </n-breadcrumb-item>
        </n-breadcrumb>
      </div>
      <n-grid :cols="2">
        <n-grid-item>
          <p class="title" >Hi {{customerName}},</p>
        </n-grid-item>
        <n-grid-item>
          <h2 class="title_mix">REF: {{salesorderDetail.refnumber}}</h2>
          <h2 class="title_mobile">REF: {{salesorderDetail.refnumber}}</h2>
        </n-grid-item>
        <n-grid-item>
          <p style="font-weight:400; margin:0">How can we help you today?</p>
        </n-grid-item>
        <n-grid-item>
          <p style="float:right; margin:0; font-size:12px; visibility: hidden;" v-if="Object.keys(salesorderDetail).length !== 0">{{ salesorderCreatedTime(salesorderDetail.timeinvoiced?.date)}}</p> 
        </n-grid-item>
      </n-grid>

        <!--<div class="font-weight">
          <h2 class="title_mix">REF: {{salesorderDetail.refnumber}}</h2>
          <h2 class="title_mobile">REF: {{salesorderDetail.refnumber}}</h2>
          <p class="title" style="margin:30px 0;">Hi, {{customerName}}</p>
          <br/>
          <p style="float:right; margin:0; font-size:12px" v-if="Object.keys(salesorderDetail).length !== 0">{{ salesorderCreatedTime(salesorderDetail.timeinvoiced?.date)}}</p> 
          <small style="font-weight:400">How can we help you today</small>
        </div>-->
        
        <div>
            <n-list>
                <n-list-item v-for="question in questions" :key="question.title" style="cursor: pointer" @click="$router.push({ path: question.route})">
                  <template #suffix>
                      <span>
                      <Icon>
                          <ArrowForward />
                      </Icon>
                      </span>
                  </template>
                  <p class="font-weight sub-title">{{question.title}}</p>
                  <p class="font-weight sub-desc">{{question.desc}}</p>
                </n-list-item>
            </n-list>
        </div>
    </div>
    <div v-if="isCSModalShow == true">
    <CustomerServiceModal :isCSModalshow="isCSModalShow" :salesorderDetails="salesorderDetail" @close="isCSModalShow = !isCSModalShow"/>
    </div>
</template>

<script>
import {NBreadcrumb, NBreadcrumbItem, NList, NListItem, NSpin, NGrid, NGridItem} from "naive-ui";
import{ArrowForward, HomeOutline} from "@vicons/ionicons5"
import {Icon} from "@vicons/utils"
import {ref, onMounted, reactive, toRefs, computed } from "vue";
import {useRoute} from "vue-router";
import axios from "axios";
import CustomerServiceModal from "./customer-service-modal/Customer-Service-Modal"
import {useReCaptcha} from "vue-recaptcha-v3"
import RobotCheckModal from "../../components/result/robotcheck/Robot-Check-Modal"

export default {
  name: "Help-Center",
  components:{
    NBreadcrumb,
    NBreadcrumbItem,
    NList,
    NListItem,
    ArrowForward,
    HomeOutline,
    Icon,
    NSpin,
    CustomerServiceModal,
    RobotCheckModal,
    NGrid, NGridItem
  },
  setup(){
    const route = useRoute();

    const orderId = ref(route.params.hashcode)
    const { executeRecaptcha, recaptchaLoaded  } = useReCaptcha();

    const isCSModalShow = ref(false) //customer service modal 

    const isPageLoading = ref(true)

    const isRobotCheck = ref(false)



    const salesorderDetails = reactive({
      salesorderDetail:{}
    })

    const customerName = computed(()=> salesorderDetails.salesorderDetail.billpersonfullname?.split(" ")[0])

    const questions = ref([
      {title:'View Order Status', route:`/helpcenter/status/${route.params.hashcode}`, desc:"Get the latest shipping details"},
      // {title:"Order Enquiry", route:`/helpcenter/enquiry/${route.params.hashcode}`}
      // {title:'Escalate to Customer Service Manager', route:`/`, desc:"We will reply much quicker than telephone queries!"},
    ])

    const CSModalshowHandler = () =>{
        isCSModalShow.value = true
    }

    // call data from api
    const getData = async() =>{
      await recaptchaLoaded()
      const token = await executeRecaptcha("homepage");
      const params = new URLSearchParams();
      params.append('recaptchakey', token);

      // axios.all([axios.post(`recaptcha/signup`, params), axios.get(`orders/${route.params.hashcode}` )])
      axios.all([axios.post(`https://help-api.tradedepot.co.nz/api/v1/recaptcha/signup`, params), axios.get(`https://business-api.tradedepot.co.nz/Help/getTrackInfoByHashCode?hashcode=${route.params.hashcode}` )])
        .then(axios.spread((recaptcha,dwData) => {
          console.log(recaptcha,"recaaptcha")
          if(recaptcha.data.score >= 0.5){
            salesorderDetails.salesorderDetail = dwData.data.data.salesorder
            isPageLoading.value = false
          }else{
            isRobotCheck.value = true
            
          }
          
        }))
        .catch(err => console.err(err))

      // axios.post(`recaptcha/signup`, params)
      // // axios({method: "post", url: "recaptcha/signup", data:{recaptchakey:token}})
      //   .then(res => console.log(res,"recap"))
      //   .catch(err => console.log(err))

      // axios.get(`orders/${route.params.hashcode}` )
      //   .then(res => {
      //     salesorderDetails.salesorderDetail = res.data.data.salesorder
      //     })
      //     .then(() => isPageLoading.value = false)
      //   .catch(err => console.log(err))
    }

    onMounted(()=>{
      getData()
    })

    const salesorderCreatedTime = (time) => {
      const hours = new Date(time).getHours()
      const timePeriod = hours >= 12? "pm" : "am"
      return new Date(time).toUTCString().substr(4,18) + timePeriod
    }

    return{
      questions,
      route,
      orderId,
      isPageLoading,
      ...toRefs(salesorderDetails),
      salesorderCreatedTime,
      customerName,
      isCSModalShow,
      CSModalshowHandler,
      isRobotCheck
      }
  }
}
</script>

<style scoped>
.content{
  padding-top:20px
}

.loading{
  width:100%;
  height:100%;
  position: absolute;
  left:0;
  background-color: rgba(0,0,0,0.65);
  z-index:100
}

.breadCrumb{
  margin-top:10px
}

.title{
  display:inline;
  font-size: 25px;
  line-height: 20px;
  margin:30px 0;
}

.title_mix{
  font-weight: bold;
  font-size: 18px;
  margin:0;
  float:right
}

.title_mobile{
    display:none;
}

.font-weight{
  font-weight: 500;
}

.sub-title{
  margin:0;
  font-size: 18px;
}

.sub-desc{
  margin:0
}

.breadCrumb_mobile{
    display:none
  }

@media only screen and (max-width: 1024px) {
  .title_mobile{
    display:inline;
    font-size: 15px;
    margin:0;
    float:right
  }

  .title_mix{
  display:none
  } 

  .sub-title{
    font-size: 16px
  }
  
  .sub-desc{
    font-size: 11px
  }
}

@media only screen and (max-width:425px){
  .breadCrumb_web{
    display:none
  }

  .breadCrumb_mobile{
    display:block
  }
}
</style>